import React from 'react'
import './RefundPolicy.css'

const RefundPolicy = () => {
    return (
        <div className='top-spacing'>
            <div className='container spaceing-box'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='term-headings'>
                            <h2>Refund Policy</h2>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='conditions-per'>
                            <p>Online businesses selling products are required to present their product return policy and refund policy.
                            </p>
                            <p>This is important in order to comply with consumer protection regulations. It avoids claims by customers that are not satisfied with products they purchase. </p>
                            <p>Please note that many websites dealing with sale of physical goods establish a refund policy as a separate document. This normally includes more instructions and information on the procedures for returns and refunding.</p>
                        </div>
                    </div>
                </div>
            </div>
            <hr className='hori-line' />
            <div className='container spaceing-box'>
                <div className='row mt-3'>
                    <div className='col-md-12'>

                        <div className='text-bottom2'>
                            <p>
                                The explanations and information provided herein are only general explanations, information and samples. You should not rely on this article as legal advice or as recommendations regarding what you should actually do. We recommend that you seek legal advice to help you understand and to assist you in the creation of your refund/return policy.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default RefundPolicy;



